import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TestPlanActionsModal from './TestPlanActionsModal/TestPlanActionsModal';
import { BasePage } from '~src/components/pages/BasePage/BasePage';

const TestPlanActionsModalWrapper = () => {
  const { partnerId } = useParams<{ partnerId: string }>();
  const navigate = useNavigate();

  const handleSuccess = (id: string) => {
    navigate(`/app/partner/${partnerId}/api/test-plans?newPlan=${id}`);
  };

  return (
    <BasePage>
      <TestPlanActionsModal partnerId={partnerId || ''} action="New" onNewTestPlanComplete={handleSuccess} />
    </BasePage>
  );
};

export default TestPlanActionsModalWrapper;
